@if (alert && state) {
    <div class="modal" [@fade]
         [ngClass]="{
        'confirmation':alert.type == FuiAlertType.CONFIRMATION,
        'error':alert.type == FuiAlertType.ERROR,
        'warning':alert.type == FuiAlertType.WARNING,
        'success':alert.type == FuiAlertType.SUCCESS,
        'information':alert.type == FuiAlertType.INFORMATION
     }"
    >
        <div class="window">
            <div class="window-main">
                <div class="window-main-type">
                    @switch (alert.type) {
                        @case (FuiAlertType.CONFIRMATION) {
                            <div class="window-main-type-media">
                                <fui-icon [icon]="'success'" [height]="28" [width]="28"></fui-icon>
                            </div>
                        }
                        @case (FuiAlertType.ERROR) {
                            <div class="window-main-type-media">
                                <fui-icon [icon]="'error'" [height]="28" [width]="28"></fui-icon>
                            </div>
                        }
                        @case (FuiAlertType.INFORMATION) {
                            <div class="window-main-type-media">
                                <fui-icon [icon]="'information'" [height]="28" [width]="28"></fui-icon>
                            </div>
                        }
                        @case (FuiAlertType.WARNING) {
                            <div class="window-main-type-media">
                                <fui-icon [icon]="'error'" [height]="28" [width]="28"></fui-icon>
                            </div>
                        }
                        @case (FuiAlertType.SUCCESS) {
                            <div class="window-main-type-media">
                                <fui-icon [icon]="'success'" [height]="28" [width]="28"></fui-icon>
                            </div>
                        }
                    }
                    <div class="window-main-type-label">
                        <div class="window-main-type-label-title" id="alert-label">
                            <span [innerHTML]="alert.title | translate:alert.params"></span>
                        </div>
                    </div>
                </div>
                <div class="window-main-message">
                    <div class="window-main-message-title" id="alert-message">
                        <span [innerHTML]="alert.message | translate:alert.params"></span>
                    </div>
                </div>
                @for (input of alert.inputs; track input) {
                    @if (input.type === FUIAlertInputType.TEXT) {
                        <fui-edit-text-input class="window-main-input"
                                             [forceRequired]="input.required" [label]="input.label"
                                             [(ngModel)]="inputs[input.name]"></fui-edit-text-input>
                    }
                    @if (input.type === FUIAlertInputType.TEXT_AREA) {
                        <fui-edit-textarea-input class="window-main-input"
                                                 [forceRequired]="input.required" [label]="input.label"
                                                 [(ngModel)]="inputs[input.name]"></fui-edit-textarea-input>
                    }
                }
            </div>
            <div class="window-footer">
                @for (action of alert.actions; track action) {
                    <fui-choice-button (click)="clickAction(action)"
                                       [title]="action.label" [attr.action-name]="action.name"></fui-choice-button>
                }
            </div>
        </div>
    </div>
}
